import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export function useSagesApi() {
    const callApi = useApiCall();

    const checkTestConnection = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.TEST_CONNECTION, data, onSuccess, onError);
    };
    const saveConnection = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_CONNECTION, data, onSuccess, onError);
    };
    {/* sync api*/ }
    const syncAccountGroups = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_ACCOUNT_GROUPS, data, onSuccess, onError);
    };
    const syncAccount = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_ACCOUNT, data, onSuccess, onError);
    };
    const syncFinancialBook = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_FINANCIAL_BOOK, data, onSuccess, onError);
    };
    const syncItemGL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_ITEM_GL, data, onSuccess, onError);
    };
    const syncLocation = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_LOCATION, data, onSuccess, onError);
    };
    const syncDepartment = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_DEPARTMENT, data, onSuccess, onError);
    };
    const syncVendor = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SYNC_VENDOR, data, onSuccess, onError);
    };
    {/* sync api*/ }

    {/* get api*/ }
    const getSyncAccountGroups = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SYNC_ACCOUNT_GROUPS, data, onSuccess, onError);
    };
    const getSyncAccount = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SYNC_ACCOUNT, data, onSuccess, onError);
    };
    const getSyncFinancialBook = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SYNC_FINANCIAL_BOOK, data, onSuccess, onError);
    };
    const getSyncItemGL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SYNC_ITEM_GL, data, onSuccess, onError);
    };
    const getSageFacilityList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SAGE_FACILITY_LIST, data, onSuccess, onError);
    };
    const getSageDepartmentList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SAGE_DEPARTMENT_LIST, data, onSuccess, onError);
    };
    {/* sync api*/ }

    const getAssetSubGroupCode = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_ASSET_SUB_GROUP_CODE, data, onSuccess, onError);
    };
    const getAssetSubGroupList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_ASSET_SUB_GROUP_LIST, data, onSuccess, onError);
    };
    const saveAssetSubGroup = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_ASSET_SUB_GROUP, data, onSuccess, onError);
    };
    const deleteAssetGroup = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.DELETE_ASSET_GROUP, data, onSuccess, onError);
    };

    const getAssetMappingList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_ASSET_MAPPING_LIST, data, onSuccess, onError);
    };
    const saveAssetMapping = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_ASSET_MAPPING, data, onSuccess, onError);
    };

    const getAssetInventoryMappingList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_ASSET_INVENTORY_MAPPING_LIST, data, onSuccess, onError);
    };
    const saveAssetInventoryMapping = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_ASSET_INVENTORY_MAPPING, data, onSuccess, onError);
    };

    const getAssetOtherMapping = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_ASSET_OTHER_MAPPING_LIST, data, onSuccess, onError);
    };
    const saveAssetOtherMapping = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_ASSET_OTHER_MAPPING, data, onSuccess, onError);
    };
    const SaveSageAssetGroupExpenseAccountMapping = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.SAVE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING, data, onSuccess, onError);
    };
    const PostAssetDisposalToSage = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.POST_ASSET_DISPOSAL_TO_SAGE, data, onSuccess, onError);
    }
    const PostAssetRevaluationToSage = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.POST_ASSET_REVALUATION_TO_SAGE, data, onSuccess, onError);
    }
    const PostAssetDepreciationToSage = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.POST_ASSET_DEPRECIATION_TO_SAGE, data, onSuccess, onError);
    }

    const getRefNumberList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_REF_NUMBER_LIST, data, onSuccess, onError);
    };
    const getDefaultDataSync = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_DEFAULT_DATA_SYNC, data, onSuccess, onError);
    };

    const getSageConfig = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SAGE_CONFIG, data, onSuccess, onError);
    };
    const getSageAssetGroupExpenseAccountMappingList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_SAGE_ASSET_GROUP_EXPENSE_ACCOUNT_MAPPING_LIST, data, onSuccess, onError);
    };
    const postAll = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.POST_ALL, data, onSuccess, onError);
    }
    const getPostAllStatus = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.POST_ALL_STATUS, data, onSuccess, onError);
    }
    const getUsedAccmDeprAccountList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_USED_ACCUMULATED_DEPRECIATION_ACCOUNT_LIST, data, onSuccess, onError);
    };
    const getUsedAccountList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.SAGE.GET_USED_ACCOUNT_LIST, data, onSuccess, onError);
    };

    return {
        checkTestConnection,
        saveConnection,
        syncAccountGroups,
        syncAccount,
        syncFinancialBook,
        syncItemGL,
        getSyncAccountGroups,
        getSyncAccount,
        getSyncFinancialBook,
        getSyncItemGL,
        getAssetSubGroupList,
        saveAssetSubGroup,
        getAssetMappingList,
        saveAssetMapping,
        getAssetOtherMapping,
        saveAssetOtherMapping,
        deleteAssetGroup,
        saveAssetInventoryMapping,
        getAssetInventoryMappingList,
        getAssetSubGroupCode,
        PostAssetDisposalToSage,
        PostAssetRevaluationToSage,
        PostAssetDepreciationToSage,
        syncLocation,
        syncDepartment,
        getRefNumberList,
        getSageFacilityList,
        getSageDepartmentList,
        getDefaultDataSync,
        getSageConfig,
        syncVendor,
        SaveSageAssetGroupExpenseAccountMapping,
        getSageAssetGroupExpenseAccountMappingList,
        postAll,
        getUsedAccmDeprAccountList,
        getUsedAccountList,
        getPostAllStatus
    };
}